import script from "./NavBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./NavBar.vue?vue&type=script&lang=ts&setup=true"

import "./NavBar.vue?vue&type=style&index=0&id=283f2fe0&lang=scss"

const __exports__ = script;

export default __exports__